module.exports = __webpack_public_path__ + "media/images/app/testimonials/star-29e8131de61ae16d36bf328781bac7fe.svg";